export default __webpack_public_path__ + "static/media/tweet1.dd854c51.PNG";